import { Hero } from "../components/Hero";
import { BranchHighlights } from "../components/BranchHighlights";
import { Facilities } from "../components/Facilities";
import { Services } from "../components/Services";
import { Doorstep } from "../components/Doorstep";

export const Home = () => {
  return (
    <>
      <Hero />
      <BranchHighlights />
      <Facilities />
      <Services />
      <Doorstep />
    </>
  );
};
